import * as types from '../types';
import { ILeadSourcesApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class LeadSourcesHttpApi extends HttpApi implements ILeadSourcesApi {
  async listLeadSources(): Promise<types.LeadSource[]> {
    // Backend returns every lead source for the tenant in one unpaginated array.
    const response = await this.http.get<types.APIResponse<types.LeadSource[]>>('/lead-sources');
    return response.data.data;
  }

  async getLeadSource(id: string): Promise<types.LeadSource> {
    const response = await this.http.get<types.APIResponse<types.LeadSource>>(`/lead-sources/${id}`);
    return response.data.data;
  }

  async getLeadSourceEffectiveUtm(id: string): Promise<types.UtmValues> {
    const response = await this.http.get<types.APIResponse<types.UtmValues>>(
      `/lead-sources/${id}/effective-utm`
    );
    return response.data.data;
  }

  async createLeadSource(data: types.CreateLeadSourceRequest): Promise<types.LeadSource> {
    const response = await this.http.post<types.APIResponse<types.LeadSource>>('/lead-sources', data);
    return response.data.data;
  }

  async updateLeadSource(id: string, data: types.UpdateLeadSourceRequest): Promise<types.LeadSource> {
    const response = await this.http.patch<types.APIResponse<types.LeadSource>>(`/lead-sources/${id}`, data);
    return response.data.data;
  }

  async deactivateLeadSource(id: string): Promise<types.LeadSource> {
    const response = await this.http.post<types.APIResponse<types.LeadSource>>(
      `/lead-sources/${id}/deactivate`
    );
    return response.data.data;
  }

  async deleteLeadSource(id: string): Promise<void> {
    await this.http.delete(`/lead-sources/${id}`);
  }

  async listCustomerLeadSourceHistory(customerId: string): Promise<types.CustomerLeadSourceHistoryEntry[]> {
    const response = await this.http.get<types.APIResponse<types.CustomerLeadSourceHistoryEntry[]>>(
      `/customers/${customerId}/lead-source-history`
    );
    return response.data.data;
  }
}
